function viewTransition(callback) {
    // Check if the browser supports View Transitions
    if(!document.startViewTransition) return callback()
    document.startViewTransition(() => {
        callback()
    })
}

function formatMoney(amount) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
    }).format(amount)
}